<template>
  <section class="customers dashboard-grid">
    <slot name="menu"></slot>
    <div class="dashboard-grid__main">
      <div class="dashboard-grid__main__header">
        <slot name="title"></slot>
        <div class="no-select search">
          <IconSearch size="sm" />
          <input
            id="modelPath"
            ref="search__field"
            v-model="searchTerm"
            class="form-control search__field"
            type="text"
            placeholder="Buscar cliente ou domínio"
            autocomplete="off"
          />
        </div>
      </div>
      <CustomTable
        v-if="listForTable.length > 0"
        id="customer-list"
        class="dashboard-grid__table custom-scrollbar"
        :cols="tableHeaders"
        :list="listForTable"
      >
        <template #actions="{ row: customer }">
          <div class="column-actions">
            <button
              class="column-actions__cta"
              title="Acessar cliente"
              :class="{ 'column-actions__cta--disabled': !!customer.inactive }"
              :disabled="!!customer.inactive"
              @click="goToCustomer(customer)"
            >
              Acessar
            </button>
          </div>
        </template>
      </CustomTable>
      <div
        v-else
        class="settings-grid__empty-state"
      >
        Sem clientes para exibir 😿
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex';
import slugify from 'slugify';

import CustomTable from '@/components/CustomTable.vue';
import IconSearch from '@/components/icons/IconSearch.vue';

export default {
  name: 'Customers',
  components: {
    CustomTable,
    IconSearch,
  },
  data() {
    return {
      searchTerm: '',
      tableHeaders: [
        {
          name: 'name',
          label: 'Cliente',
        },
        {
          name: 'domain',
          label: 'Domínio',
          title: 'otherDomains',
        },
        {
          name: 'publishedPages',
          label: 'Páginas publicadas',
          maxWidth: '120px',
        },
        {
          name: 'draftPages',
          label: 'Páginas em rascunho',
          maxWidth: '130px',
        },
        {
          name: 'status',
          label: 'Status',
          maxWidth: '100px',
        },
        {
          name: 'actions',
          label: 'Ações',
          maxWidth: '100px',
          isSortable: false,
        },
      ],
    };
  },
  computed: {
    listForTable() {
      return this.searchTerm.length > 0
        ? this.foundOutCustomers
        : this.allCustomers;
    },
    foundOutCustomers() {
      return this.allCustomers.filter((customer) =>
        this.isCustomerMatch(customer),
      );
    },
    allCustomers() {
      return this.dashboard.customers.map(
        ({ customer = '', domain, publishedPages, draftPages, inactive }) => {
          const status = inactive ? 'Inativo' : 'Ativo';
          let mainDomain = '';
          let elTitle = '';

          if (domain && domain.length > 0) {
            mainDomain = domain.shift();

            if (domain.length) {
              mainDomain += ` (${domain.length})`;

              domain.forEach((currentDomain) => {
                elTitle += `${currentDomain}\n`;
              });
            }
          }

          return {
            name: customer,
            domain: mainDomain,
            otherDomains: elTitle,
            publishedPages,
            draftPages,
            status,
          };
        },
      );
    },
    ...mapState(['dashboard']),
  },
  methods: {
    isCustomerMatch(customer) {
      const term = slugify(this.searchTerm, { lower: true, strict: true });
      const { name, domain, otherDomains } = customer;

      const customerString = [name, domain, otherDomains].join(' ');

      const customerSlug = slugify(customerString, {
        lower: true,
        strict: true,
      });

      return customerSlug.includes(term);
    },
    goToCustomer(customer) {
      this.$store.dispatch('goToCustomer', customer.name).then(() => {
        // force refresh
        window.location.href = `${window.location.origin}/`;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.customers {
  .column-actions {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;

    &__cta {
      color: $crm-blue-primary;
      font-weight: $lb-medium;
      padding: 6px;

      &:hover {
        text-decoration: underline;
      }

      &--disabled {
        text-decoration: none;
        color: #7f7f7f;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>
